module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (57).68024a27.jpg";